import { get } from '../../../shared/api/apiService';
import {
  DocumentationItem,
  DocumentationTab,
  DocumentationTabsResponse,
} from './types';

export const DOCUMENTATION_API_BASE_PATH = '/resource-broker/api/v2';
export const DOCUMENTATION_RESOURCE_PATH =
  `${DOCUMENTATION_API_BASE_PATH}/resources/documentation`;
export const DOCS_V2_BASE_ROUTE = '/docs-v2';

export const documentationQueryDefaults = {
  staleTime: 5 * 60 * 1000,
  retry: 3,
} as const;

export const documentationQueryKeys = {
  all: ['documentation'] as const,
  tabs: ['documentation', 'tabs'] as const,
  item: (documentTagName: string) =>
    ['documentation', 'item', documentTagName] as const,
};

export async function fetchDocumentationTabs(
  apiUrl: string,
  idToken: string,
): Promise<DocumentationTab[]> {
  const response = await get<DocumentationTabsResponse>(
    '/resources/documentation/tabs',
    apiUrl,
    idToken,
  );

  return response.tabs ?? [];
}

export async function fetchDocumentationItem(
  apiUrl: string,
  idToken: string,
  documentTagName: string,
): Promise<DocumentationItem> {
  const encodedDocumentTagName = documentTagName
    .split('/')
    .filter(Boolean)
    .map(encodeURIComponent)
    .join('/');

  return get<DocumentationItem>(
    `/resources/documentation/${encodedDocumentTagName}`,
    apiUrl,
    idToken,
  );
}
